<template>
  <div class="float-sidebar-shell" :class="{ 'locale-en': isEnglishLocale() }">
    <KefuFloat
      ref="kefu"
      :show-trigger="false"
      :mobile-mode="isMobileViewport"
      @badge-change="handleBadgeChange"
      @chat-state-change="handleChatStateChange"
    />

    <div v-show="!isMobileViewport" class="desktop-sidebar">
      <button
        type="button"
        class="desktop-item desktop-kefu-item"
        :class="{ active: isChatOpen }"
        @click="openKefu"
      >
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
          <path d="M512 64C264.6 64 64 238.7 64 456c0 124.5 68.6 236.2 176 310.7V896l138.7-76.1c42.5 11.8 87.5 18.1 133.3 18.1 247.4 0 448-174.7 448-382S759.4 64 512 64z m32 544H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32z m128-160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
        </svg>
        <span class="desktop-label">{{ $t('客服') }}</span>
        <span class="desktop-badge" v-if="unreadCount > 0">{{ displayUnreadCount }}</span>
      </button>
      <FloatQrcode />
    </div>

    <div v-show="isMobileViewport" class="mobile-sidebar">
      <transition name="sidebar-fade">
        <div
          v-if="mobileActionsOpen || mobileQrType"
          class="mobile-overlay"
          @click="closeMobileOverlays"
        ></div>
      </transition>

      <transition name="mobile-panel">
        <div v-if="mobileActionsOpen" class="mobile-actions-panel">
          <button type="button" class="mobile-action-item" @click="openKefu">
            <div class="mobile-action-icon">
              <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
                <path d="M512 64C264.6 64 64 238.7 64 456c0 124.5 68.6 236.2 176 310.7V896l138.7-76.1c42.5 11.8 87.5 18.1 133.3 18.1 247.4 0 448-174.7 448-382S759.4 64 512 64z m32 544H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32z m128-160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
              </svg>
            </div>
            <span>{{ $t('客服') }}</span>
          </button>

          <button type="button" class="mobile-action-item" @click="openMobileQr('official')">
            <div class="mobile-action-icon">
              <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
                <path d="M416 128c-153.6 0-288 115.2-288 268.8 0 89.6 51.2 166.4 128 217.6l-32 96 108.8-57.6c25.6 6.4 51.2 12.8 83.2 12.8 10.7 0 21.3-0.6 32-1.7-6.7-22.9-10.7-46.8-10.7-71.5 0-140.8 128-256 288-256 10.7 0 21.3 0.6 32 1.7C726.7 213.3 583.4 128 416 128z m-83.2 192c-25.6 0-44.8-19.2-44.8-44.8s19.2-44.8 44.8-44.8 44.8 19.2 44.8 44.8-19.2 44.8-44.8 44.8z m166.4 0c-25.6 0-44.8-19.2-44.8-44.8s19.2-44.8 44.8-44.8 44.8 19.2 44.8 44.8-19.2 44.8-44.8 44.8z"/>
                <path d="M725.3 396.8c-140.8 0-256 102.4-256 230.4s115.2 230.4 256 230.4c25.6 0 51.2-6.4 76.8-12.8l83.2 51.2-25.6-76.8c64-44.8 108.8-115.2 108.8-192-6.4-128-121.6-230.4-243.2-230.4z m-64 192c-19.2 0-32-12.8-32-32s12.8-32 32-32 32 12.8 32 32-12.8 32-32 32z m128 0c-19.2 0-32-12.8-32-32s12.8-32 32-32 32 12.8 32 32-12.8 32-32 32z"/>
              </svg>
            </div>
            <span>{{ $t('公众号') }}</span>
          </button>

          <button type="button" class="mobile-action-item" @click="openMobileQr('mini')">
            <div class="mobile-action-icon">
              <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
                <path d="M372.825 562.682a56.32 56.32 0 1 1-112.64 0 56.32 56.32 0 0 1 112.64 0z m225.28-56.32a56.32 56.32 0 1 0 0 112.64 56.32 56.32 0 0 0 0-112.64z"/>
                <path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64z m206.336 604.16c-2.048 3.584-51.2 85.504-161.28 118.272a20.48 20.48 0 0 1-25.088-12.8 20.48 20.48 0 0 1 12.288-25.6c0.512 0 0.512-0.512 1.024-0.512 89.088-26.624 131.072-93.696 131.584-94.72a20.48 20.48 0 0 1 28.16-7.168 19.968 19.968 0 0 1 13.312 22.528z m27.648-135.168c0 126.464-113.152 228.864-252.928 228.864a274.432 274.432 0 0 1-85.504-13.824l-99.328 52.736 30.72-88.064c-70.144-46.592-119.296-117.76-119.296-179.712 0-126.464 113.152-228.864 252.928-228.864h20.48c123.904 5.632 222.72 107.008 222.72 228.864h0.208z"/>
              </svg>
            </div>
            <span>{{ $t('小程序') }}</span>
          </button>

          <button type="button" class="mobile-action-item" @click="scrollToTop">
            <div class="mobile-action-icon">
              <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
                <path d="M494.784 295.808a24.576 24.576 0 0 1 34.432 0l236.544 232.32a24.064 24.064 0 0 1 0 34.304 24.576 24.576 0 0 1-34.432 0L512 345.856 292.672 562.432a24.576 24.576 0 0 1-34.432 0 24.064 24.064 0 0 1 0-34.304l236.544-232.32z"/>
                <path d="M512 288a24.32 24.32 0 0 1 24.32 24.32v399.36a24.32 24.32 0 1 1-48.64 0V312.32A24.32 24.32 0 0 1 512 288z"/>
              </svg>
            </div>
            <span>{{ $t('顶部') }}</span>
          </button>
        </div>
      </transition>

      <transition name="sidebar-fade">
        <div v-if="mobileQrConfig" class="mobile-qr-modal">
          <button type="button" class="mobile-qr-close" @click="closeMobileOverlays">×</button>
          <div class="mobile-qr-title">{{ mobileQrConfig.title }}</div>
          <img :src="$getAssetUrl(mobileQrConfig.image)" :alt="mobileQrConfig.title" />
          <p>{{ mobileQrConfig.description }}</p>
        </div>
      </transition>

      <div class="mobile-fab-wrap" :class="{ 'is-chat-open': isChatOpen }">
        <button type="button" class="mobile-main-trigger" @click="toggleMobileActions">
          <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
            <path d="M512 64C264.6 64 64 238.7 64 456c0 124.5 68.6 236.2 176 310.7V896l138.7-76.1c42.5 11.8 87.5 18.1 133.3 18.1 247.4 0 448-174.7 448-382S759.4 64 512 64z m32 544H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32z m128-160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
          </svg>
          <span class="mobile-main-label">{{ $t('客服') }}</span>
          <span class="mobile-badge" v-if="unreadCount > 0">{{ displayUnreadCount }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FloatQrcode from '@/components/FloatQrcode.vue';
import KefuFloat from '@/components/KefuFloat.vue';

const MOBILE_BREAKPOINT = 750;

export default {
  name: 'FloatSidebar',
  components: {
    FloatQrcode,
    KefuFloat,
  },
  data() {
    return {
      unreadCount: 0,
      mobileActionsOpen: false,
      mobileQrType: '',
      isMobileViewport: false,
      isChatOpen: false,
    };
  },
  computed: {
    qrMap() {
      return {
        official: {
          title: this.$t('公众号'),
          description: this.$t('微信扫码关注公众号'),
          image: '/pcImgs/qrcode_official.jpg',
        },
        mini: {
          title: this.$t('小程序'),
          description: this.$t('微信扫码进入小程序'),
          image: '/pcImgs/qrcode_miniprogram.png',
        },
      };
    },
    displayUnreadCount() {
      return this.unreadCount > 99 ? '99+' : this.unreadCount;
    },
    mobileQrConfig() {
      return this.mobileQrType ? this.qrMap[this.mobileQrType] : null;
    },
  },
  mounted() {
    this.updateViewportMode();
    window.addEventListener('resize', this.updateViewportMode);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportMode);
  },
  methods: {
    isEnglishLocale() {
      return this.$i18n && this.$i18n.locale === 'en';
    },
    updateViewportMode() {
      const nextIsMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      const changed = this.isMobileViewport !== nextIsMobile;
      this.isMobileViewport = nextIsMobile;
      if (!nextIsMobile || changed) {
        this.closeMobileOverlays();
      }
    },
    handleBadgeChange(count) {
      this.unreadCount = Number(count) || 0;
    },
    handleChatStateChange(open) {
      this.isChatOpen = !!open;
      if (open) {
        this.closeMobileOverlays();
      }
    },
    openKefu() {
      this.closeMobileOverlays();
      if (this.$refs.kefu) {
        this.$refs.kefu.openFromExternal();
      }
    },
    toggleMobileActions() {
      if (this.isChatOpen) return;
      this.mobileQrType = '';
      this.mobileActionsOpen = !this.mobileActionsOpen;
    },
    openMobileQr(type) {
      this.mobileActionsOpen = false;
      this.mobileQrType = type;
    },
    closeMobileOverlays() {
      this.mobileActionsOpen = false;
      this.mobileQrType = '';
    },
    scrollToTop() {
      this.closeMobileOverlays();
      window.scrollTo({ behavior: 'smooth', top: 0 });
    },
  },
};
</script>

<style scoped lang="scss">
.float-sidebar-shell {
  position: relative;
  z-index: 9999;
}

.desktop-sidebar {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2px;
}

.desktop-item {
  position: relative;
  width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border: 0;
  background: #00903b;
  color: #fff;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;
}

.desktop-item:hover,
.desktop-item.active {
  background: #007a32;
  transform: translateX(-2px);
  box-shadow: 0 14px 26px rgba(0, 144, 59, 0.2);
}

.desktop-kefu-item {
  border-radius: 6px 6px 0 0;
}

.desktop-label {
  font-size: 11px;
  margin-top: 4px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.float-sidebar-shell.locale-en .desktop-item {
  width: 88px;
  padding: 12px 6px;
}

.float-sidebar-shell.locale-en .desktop-label {
  white-space: normal;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0;
  font-size: 10px;
}

.desktop-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ff3b30;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  border-radius: 9px;
  text-align: center;
  padding: 0 5px;
  box-shadow: 0 2px 6px rgba(255, 59, 48, 0.4);
}

.mobile-sidebar {
  position: relative;
}

.mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.36);
  z-index: 9996;
}

.mobile-fab-wrap {
  position: fixed;
  right: 16px;
  bottom: 20px;
  z-index: 9999;
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.mobile-fab-wrap.is-chat-open {
  opacity: 0;
  transform: translateY(24px);
  pointer-events: none;
}

.mobile-main-trigger {
  position: relative;
  width: 58px;
  height: 58px;
  border: 0;
  border-radius: 18px;
  background: linear-gradient(135deg, #00903b, #14a44d);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 28px rgba(0, 144, 59, 0.28);
  cursor: pointer;
}

.mobile-main-label {
  font-size: 11px;
  margin-top: 2px;
}

.float-sidebar-shell.locale-en .mobile-main-trigger {
  width: 68px;
  height: 68px;
  border-radius: 20px;
}

.float-sidebar-shell.locale-en .mobile-main-label {
  padding: 0 6px;
  font-size: 10px;
  line-height: 1.2;
  white-space: normal;
  text-align: center;
}

.mobile-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #ff3b30;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 2px 6px rgba(255, 59, 48, 0.4);
}

.mobile-actions-panel {
  position: fixed;
  right: 16px;
  bottom: 90px;
  width: min(320px, calc(100vw - 32px));
  padding: 16px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.18);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  z-index: 9998;
}

.mobile-action-item {
  border: 0;
  border-radius: 16px;
  background: #f2f7f3;
  color: #0f172a;
  padding: 14px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.mobile-action-item:hover,
.mobile-action-item:active {
  background: #e4f5e8;
  transform: translateY(-1px);
}

.mobile-action-icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: #00903b;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-action-item span {
  font-size: 13px;
  font-weight: 500;
}

.float-sidebar-shell.locale-en .mobile-action-item span {
  font-size: 12px;
  line-height: 1.25;
  white-space: normal;
  text-align: center;
  word-break: break-word;
}

.mobile-qr-modal {
  position: fixed;
  left: 16px;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 22px;
  padding: 22px 20px 20px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.2);
  z-index: 9998;
}

.mobile-qr-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: #f3f4f6;
  color: #64748b;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.mobile-qr-title {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 14px;
}

.mobile-qr-modal img {
  width: min(240px, 70vw);
  height: min(240px, 70vw);
  border-radius: 14px;
  display: block;
  margin: 0 auto;
}

.mobile-qr-modal p {
  margin: 14px 0 0;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}

.sidebar-fade-enter-active,
.sidebar-fade-leave-active {
  transition: opacity 0.22s ease;
}

.sidebar-fade-enter,
.sidebar-fade-leave-to {
  opacity: 0;
}

.mobile-panel-enter-active,
.mobile-panel-leave-active {
  transition: transform 0.22s ease, opacity 0.22s ease;
}

.mobile-panel-enter,
.mobile-panel-leave-to {
  opacity: 0;
  transform: translateY(16px);
}

@media screen and (min-width: 751px) {
  .mobile-sidebar {
    display: none;
  }
}

@media screen and (max-width: 750px) {
  .desktop-sidebar {
    display: none;
  }
}
</style>
